import React from 'react';
import { useLocation } from 'react-router-dom';
import { Languages } from 'lucide-react';
import { isTranslatedPath } from '../i18n/locales';
import { useContent, useLocale } from '../i18n/LocaleProvider';

/**
 * States plainly what a visitor is reading: a draft translation pending the
 * Group's sign-off, or an English-only page. Never shown in English.
 */
export default function TranslationNotice() {
  const { locale, setLocale, autoDetected } = useLocale();
  const { UI } = useContent();
  const { pathname } = useLocation();

  if (locale === 'en') return null;
  const translated = isTranslatedPath(pathname);
  const auto = autoDetected && translated;

  return (
    <div className="lang-notice" role="note" data-testid="translation-notice">
      <div className="u-container lang-notice__inner">
        <Languages size={16} aria-hidden="true" className="lang-notice__icon" />
        <span className="lang-notice__label">
          {auto ? UI.common.autoLabel : translated ? UI.common.draftLabel : UI.common.englishOnlyLabel}
        </span>
        <p className="lang-notice__text">
          {auto
            ? UI.common.autoNotice
            : translated
              ? UI.common.draftNotice
              : UI.common.englishOnlyNotice}
        </p>
        <button
          type="button"
          className="lang-notice__action"
          onClick={() => setLocale('en')}
          data-testid="translation-notice-english"
        >
          {UI.common.readInEnglish}
        </button>
      </div>
    </div>
  );
}
